import { useState, useEffect } from 'react'
import Inscripto from './inscripto.js'
import Elemento from './elemento.js'
import * as XLSX from 'xlsx/xlsx.mjs'

export default function Data({token, evento, eventos, setCual, recargar, setRecargar, quien}) {
  const back = "https://inscripcion.ar:" + evento.puerto + "/"
  const backCods = "https://inscripcion.ar:" + '8000' + "/"

  const [preinscriptos, setPreinscriptos] = useState([])
  const [c_e, setC_E] = useState(0)
  const [apellido, setApellido] = useState('')
  const [nombre, setNombre] = useState('')
  const [email, setEmail] = useState('')
  const [seleccionar_t, setSeleccionar_t] = useState(false)
  const [updData, setUpdData] = useState({id: 0})
  const [desde, setDesde] = useState(1)
  const formato_eitqueta = "text-gray-50"
  const [total,setTotal] = useState(0)
  const [filtrados, setFiltrados] = useState(0)
  const [mostrar, setMostrar] = useState([])
  const [actualizar, setActualizar] = useState(0)
  const [desdeId, setDesdeId] = useState(0)
  const [hastaId, setHastaId] = useState(0)
  const [si, setSi] = useState(0)
  const [no, setNo] = useState(0)
  const [acep, setAcep] = useState('0')
  const [codigos, setCodigos] = useState([])
  const [codigo, setCodigo] = useState('0')
  const [mostrarcods, setMostrarcods] = useState([])

 
  useEffect (() => {
     
    const t = preinscriptos.filter((a) => {
      console.log(a.codigo)
     return (
      (a.id>= desdeId && a.id <= hastaId) &&
      (a.apellido === null || a.apellido.toLowerCase().includes(apellido.toLowerCase())) && 
      (a.nombre === null || a.nombre.toLowerCase().includes(nombre.toLowerCase())) && 
      (a.email === null || a.email.toLowerCase().includes(email.toLowerCase())) &&
      (a.codigo && (codigo === '0' || a.codigo.toLowerCase() === codigo)) &&
      (acep==='0' || a.resp===acep)
      )
    })
    setFiltrados(t)
    const u = t.map((a) => (
        <Elemento key={a.id} obj={a} elegir={elegir} setUpdData={setUpdData} evento={evento}/>
    ))
    setMostrar(u)
    const v = t.filter(e => e.s).length
    setC_E(v)
  }, [apellido, email, preinscriptos, evento, acep, desdeId, hastaId,c_e, codigo])



  useEffect (() => {
    const traer_inscripitos = () => {
    fetch(back + 'admin/traer_inscriptos', {
      method: 'GET',
      headers: {
      'Authorization': 'Bearer ' + token
    }})
    .then (response => response.json())
    .then (a => {
      const t = a.map((e) => {return {...e, s: false}})  
      setPreinscriptos(t)
      setTotal (t.length)
      const minId = a.reduce((min, item) => {
        return item.id < min ? item.id : min;
      }, Infinity);
      setDesdeId(minId)
      const maxId = a.reduce((max, item) => {
        return item.id > max ? item.id : max;
      }, 0);
      setHastaId(maxId)
      setSi (t.filter(e => ! e.codigo).length)
      setNo (t.filter(e => e.codigo).length)
    })
  }
  const traer_codigos = () => {
    const data = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json' 
      }
    }
    const tablaCods = 'convergeCods'
    fetch(backCods + 'admin/traer_codigos/' + tablaCods, data)
     
    .then (response => response.json())
    .then (a => {
      setCodigos(a.data)
      const most = a.data.map((e,i) => {
        return (<option value={e.codigo} key={i}>{e.empresa}</option>)
      })
      setMostrarcods(most)
  })
}
  traer_inscripitos()
  traer_codigos()
  }, [actualizar, token, back, backCods])  

  useEffect(() => {
    todo(false)
  },[desdeId, hastaId])

   function elegir (z) {
    if (quien.rol===1) {
      elegir_uno(z)
      return 
    }
    const t =  filtrados.map (e => {
      if (e.id===z)
        e.s = !e.s
      return e
    })
    setFiltrados(t)
    const cuantos = t.filter(a => a.s).length
    setC_E(cuantos)
    }

  function elegir_uno (z) {
    const cuantos = filtrados.filter(a => a.s)
    if (! cuantos.length) {
      const t =  filtrados.map (e => {
        if (e.id===z)
          e.s = true
        return e
      })
      setFiltrados(t)
      setC_E(1)
    } else {
      todo(false)
      if (cuantos[0].id !== z) {
        const t = filtrados.map (e => {
        if (e.id===z)
          e.s = true
        return e
        })
        setFiltrados(t)
        setC_E(1)
      } else {
        const t = filtrados.map (e => {
          if (e.id===z)
            e.s = false
          return e
          })
          setFiltrados(t)
          setC_E(0)
      }
    }
  }
  
  function todo(z) {
    if (quien.rol===1 && z) return
    const t = preinscriptos.map (e => {return {...e, s: z}})
    setPreinscriptos(t)
    setSeleccionar_t(z)
  }

  function enviar (cual) {
    const quien = filtrados.filter(e => e.s)
    const pedidosPausados = quien.map(t => {
      const sub_t = {
        apellido: t.apellido,
        nombre: t.nombre,
        email: t.email,
        id: t.id,
        cual: cual
      }
      return () => fetch (back + 'admin/enviar_mail', {
        body: JSON.stringify(sub_t),
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json' 
        }
      })
      .then (response => response.json())
      .then (a => {
        if(a) {
          const desmarcar = filtrados.map (z => {
            if (z.id === sub_t.id)
              z.s = false
            return z
          })
          setFiltrados(desmarcar);
          const cuantos = desmarcar.filter(a => a.s).length
          setC_E(cuantos)
        }
      })
    })
    pedidosPausados.reduce((p, pnew) => p.then(() => sleep(4000)).then(pnew), Promise.resolve());
    function sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }

    function eliminar() {
      const t = preinscriptos.filter(e => e.s)
      const sub_t = {id: t[0].id}
      fetch (back + 'admin/eliminar', {
        body: JSON.stringify(sub_t),
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json' 
        }
      })
      .then (response => response.json())
      .then (a => {
        setPreinscriptos(preinscriptos.filter(e => !e.s))
        setC_E(0)
      })
    }

    function descargar(cual) {
      const d = cual ? desde : 1
      fetch(back + 'admin/traer_inscriptos/id/' + d, {
        method: 'GET',
        headers: {
        'Authorization': 'Bearer ' + token
      }})
      .then (response => response.json())
      .then (json => { 
        const nuevo = json.map(e => {
          let {...resto} = e
          delete resto.ima
          resto = {...resto, id: evento.prefijoqr + resto.id.toString().padStart(4,'0'), cuando: resto.cuando.toString().substr(0,10) + ' ' + resto.cuando.toString().substr(11,8)}
          const nuevotrim = Object.keys(resto).reduce((acc, clave) => {
            typeof resto[clave]==='string' ? acc[clave] = resto[clave].trim() : acc[clave]= resto[clave]
            return acc;
          }, {});
          return nuevotrim
        })
        const worksheet = XLSX.utils.json_to_sheet(nuevo);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Lab BCR');
        const fecha = new Date()
        const a = fecha.getFullYear().toString()
        const b = (fecha.getMonth() + 1).toString().padStart(2,'0')
        const c = fecha.getDate().toString().padStart(2,'0')
        const d = a + '-' + b +  '-' + c
        const hora = fecha.getHours().toString().padStart(2,'0')
        const minutos = fecha.getMinutes().toString().padStart(2,'0')
        const segundos = fecha.getSeconds().toString().padStart(2,'0')
        const timer = hora + '-' + minutos + '-' + segundos
        XLSX.writeFile(workbook, 'listado_inscriptos ' + d + ' ' + timer + '.xlsx')
    })
  }

  
  return (<>
        <div className="flex flex-row justify-evenly w-full text-lg bg-zinc-500 font-semibold py-2">
          <select 
            className='px-2'
            value={acep} 
            onChange={e => setAcep(e.target.value)}
          >
            <option value='0'>Todos</option>
            <option value='P'>Público</option>
            <option value='I'>Invitado</option> 
          </select>
          <button 
            name='Descargar' 
            className="border-2 px-2 border-gray-400 bg-gray-200 hover:text-white hover:bg-gray-800" 
            onClick={() => setActualizar(actualizar + 1)}
          >
            Actualizar
          </button>
        {(quien.rol===2  || quien.permisos & 1) ?
          <button 
            name='Descargar' 
            className="border-2 px-2 border-green-400 bg-green-200 hover:text-white hover:bg-green-800" 
            onClick={() => descargar(0)}
          >
            Descargar Todo
          </button>
         : ''} 
         {quien.rol===2 ? (<>
          <div className="flex flex-row w-64 justify-around">
            <button 
              name='Descargar' 
              className="border-2 px-2 border-green-400 bg-green-200 hover:text-white hover:bg-green-800" 
              onClick={() => descargar(desde)}
              >Descargar Desde
            </button> 
            <input 
              type="text"
              className="px-2 w-20 outline-0 text-right"
              value={desde}
              onChange={e => setDesde(e.target.value)}
            />  
          </div>
        </>)  
          :
          ''
          }
          {(quien.rol===2  || quien.permisos & 4) ?
           <button 
               name='Eliminarr' 
               className={c_e===1 ?
                "border-2 px-2 border-red-400 bg-red-200 text-sm hover:text-white hover:bg-red-800" 
                 :
                 "border-2 px-2 border-gray-400 cursor-not-allowed bg-gray-200"
                }
                disabled={c_e===1 ? false: true}
                onClick={() => eliminar()}
              >
                Eliminar
            </button>
          : ''}
            {(quien.rol===2  || quien.permisos & 32) ?
              <button 
                name='Enviar QR' 
                className="border-2 px-2 border-red-400 bg-red-200 text-sm hover:text-white hover:bg-red-800" 
                onClick={() => enviar('invitacion')}
                disabled
              >
                Enviar Invitación
              </button> 
              : ''}
              {(quien.rol===2  || quien.permisos & 64) ?
               <button 
                name='Enviar QR' 
                className="border-2 px-2 border-red-400 bg-red-200 text-sm hover:text-white hover:bg-red-800" 
                onClick={() => enviar('QR')}
              >
                Enviar QR
              </button> 
            : '' }
        </div>
        
        <div className="mx-2 p-1 grid grid-cols-11 bg-zinc-500 gap-x-2 place-content-start border-2 border-white items-center">
          <div className='flex flex-col'>
            <div className={formato_eitqueta}>Seleccionar</div>
            <div className='flex flex-row w-24 justify-between items-center text-sm'>
              <label className='text-white text-sm'>Desde</label>
              <input type='text' className='w-12 px-1 text-right outline-0' value={desdeId} onChange={e => setDesdeId(e.target.value)}/>
            </div>
            <div className='flex flex-row w-24 justify-between items-center text-sm'>
              <label className='text-white text-sm'>Hasta</label>
              <input type='text' className='w-12 px-1 text-right outline-0' value={hastaId} onChange={e => setHastaId(e.target.value)}/>
            </div>
        </div>

        
          <div className="flex flex-col w-32">
            <label className={formato_eitqueta}>Apellido </label>
            <input 
              type="text"
              value={apellido}
              onChange={e => setApellido(e.target.value)}
              className="w-20 bg-zinc-50 text-sm border-b-2 border-gray-400 outline-0"
            />
          </div>
          <div className="flex flex-col w-32">
            <label className={formato_eitqueta}>Nombre </label>
            <input 
              type="text"
              value={nombre}
              onChange={e => setNombre(e.target.value)}
              className="w-20 bg-zinc-50 text-sm border-b-2 border-gray-400 outline-0"
            />
          </div>
          <div className="w-32 flex flex-col">
          <label className={formato_eitqueta}>E - mail</label>
            <input 
              type="text"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-20 bg-zinc-50 text-sm border-b-2 border-gray-400 outline-0"
            />
          </div>
           <div className="w-32 flex flex-col">
          <label className={formato_eitqueta}>Empresa</label>
            <select 
              value={codigo}
              onChange={e => setCodigo(e.target.value)}
              className="w-20 bg-zinc-50 text-sm border-b-2 border-gray-400 outline-0"
            >
            <option value ='0'>Todas</option>
            {mostrarcods}
          </select>
          </div>
          <div className="flex flex-col items-center text-white">
            <label>Insc</label>
            <label>{total}</label>
          </div>
          <div className="flex flex-col items-center text-white">
            <label>en pantalla</label>
            <label>{filtrados.length}</label>
          </div>
          <div className="flex flex-col items-center text-white">
            <label>Seleccionados</label>
            <label>{c_e}</label>
          </div>
          <div className="flex flex-col items-center text-white">
            <label>Público</label>
            <label>{si}</label>
          </div>
          <div className="flex flex-col items-center text-white">
            <label>Invitados</label>
            <label>{no}</label>
          </div>
        </div>
        
        <div className="px-2 w-full text-sm h-3/4 bg-zinc-500">
          <div className="w-full flex flex-row justify-between border-b-2 border-gray-600 font-semibold">
            <input 
                  type="checkbox"
                  checked={seleccionar_t}
                  onChange={(e) => todo(e.target.checked)}
            />
            <div className="grid grid-cols-11 px-5 w-full text-gray-50">
                <label>Apellido</label>
                <label>Nombre</label>
                <label className='col-span-2'>Mail</label>
                <label>Documento</label>
                <label>Rubro</label>
                <label className='col-span-2'>Empresa</label>
                <label>Código</label>
                <label>Inscripcion</label>
                <label>ID</label>
            </div> 
          </div>
        <div className='overflow-y-auto h-3/5'>
          {mostrar}
        </div>
        <div className="mt-3">
          <Inscripto  token={token} back={back} quien={quien} setPreinscriptos={setPreinscriptos} preinscriptos={preinscriptos} updData={updData} setUpdData={setUpdData} evento={evento}/>
        </div>
      </div>
      </>)
  }